<template>
  <!-- <v-container class="pa-0"> -->
  <div>
    <!-- <v-btn small @click="createMenuItems">create menu</v-btn> -->
    <v-row class="text-center">
      <v-spacer></v-spacer>
      <v-btn small rounded @click="addItemDialog = true" color="green"
        >ADD YOUR OWN ITEM</v-btn
      >
      <!-- <v-btn small rounded @click="saveConents">save contents</v-btn> -->

      <v-spacer></v-spacer>
    </v-row>
    <v-row class="text-center">
      <!-- <v-btn small fab v-if="isMobile" @click.stop="drawer = !drawer"
        ><v-icon>mdi-dots-vertical</v-icon></v-btn
      > -->
      <!-- MENU  -->
      <v-flex xs12 sm12 md3 lg3 class="pl-1 pr-1">
        <v-expand-transition>
          <div v-if="matter">
            <!-- <v-card
              class="ma-2"
              width="auto"
              height="80vh"
              style="border-radius: 26px; border: 1px solid #64B5F6"
            > -->
            <v-navigation-drawer
              permanent
              class="ma-auto ml-4"
              height="70vh"
              width="auto"
              style="border-radius: 26px; border: 1px solid #64B5F6; overflow:auto;"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">
                    MENU
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list dense nav>
                <v-list-item-group v-model="selectedMenuItem" color="primary">
                  <v-list-item v-for="(item, i) in menuItems" :key="i">
                    <v-list-item-content>
                      <v-list-item-title v-text="item"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-navigation-drawer>
            <!-- </v-card> -->
          </div>
        </v-expand-transition>
      </v-flex>
      <!-- WORKING AREA -->
      <v-flex xs12 sm12 md6 lg6 class="pa-0">
        <v-expand-transition>
          <v-card
            outlined
            class="ma-2"
            width="auto"
            height="100%"
            style="border-radius: 26px; border: 1px solid #64B5F6; overflow: auto; "
          >
            <v-form @submit.prevent="">
              <v-autocomplete
                v-if="menuItems"
                :label="
                  `Search Within Category: ${menuItems[selectedMenuItem]}`
                "
                outlined
                rounded
                clearable
                dense
                class="ma-2"
                append-icon="mdi-magnify"
                :items="items"
                item-text="title"
                return-object
                v-model="search"
              ></v-autocomplete>
            </v-form>
            <v-progress-circular
              color="green"
              v-if="overlay"
              indeterminate
            ></v-progress-circular>
            <v-window v-model="step" style="overflow: scroll">
              <v-window-item v-for="(item, index) in items" :key="index">
                <v-card-text class="pt-0">
                  <v-card
                    class="ma-auto pa-0"
                    flat
                    style="border-radius: 26px; border: 1px solid #64B5F6; background-color: #F4FCE3;"
                  >
                    <div class="subtitle-1">
                      <!-- CATEGORY:  -->
                      {{ item.category.toUpperCase() }}
                      <v-icon right v-if="item.quantity > 0" color="green"
                        >mdi-check</v-icon
                      >
                    </div>
                    <v-text-field
                      outined
                      v-model="item.title"
                      outlined
                      rounded
                      dense
                      color="primary"
                      label="Item Title"
                      class="ma-2"
                      background-color="white"
                    ></v-text-field>

                    <v-container>
                      <v-card-text class="subtitle-1 pa-0">
                        <!-- QUANTITY LOST: -->
                        <!-- </v-card-text>
                          <v-card-text class="subtitle-1 pa-1"> -->

                        <v-text-field
                          v-model="item.quantity"
                          type="number"
                          number
                          outlined
                          rounded
                          dense
                          color="primary"
                          label="Quantity Lost"
                          background-color="white"
                        ></v-text-field>
                        <v-card-actions row class="pa-0">
                          <v-spacer></v-spacer>
                          <v-btn
                            fab
                            small
                            color="red"
                            outlined
                            :disabled="item.quantity === 0"
                            @click="item.quantity--"
                            :loading="overlay2"
                            ><v-icon>mdi-minus</v-icon></v-btn
                          >
                          <v-spacer></v-spacer>

                          <v-btn
                            fab
                            small
                            color="green"
                            outlined
                            @click="item.quantity++"
                            :disabled="overlay2"
                            :loading="overlay2"
                            ><v-icon>mdi-plus</v-icon></v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                        <v-text-field
                          class="ma-3"
                          rounded
                          outlined
                          dense
                          label="Brief description (optional)"
                          v-model="item.userDescription"
                          clearable
                          background-color="white"
                        ></v-text-field>
                        <!-- {{ item.quantity }} -->
                      </v-card-text>

                      <div class="ma-auto">
                        <v-checkbox
                          label="exclude category"
                          :value="true"
                          v-model="excludeCategory"
                          class="ma-auto"
                        ></v-checkbox>
                        <div
                          v-if="
                            item.category === 'kitchen' ||
                              item.category === 'KITCHEN'
                          "
                        >
                          <v-autocomplete
                            :items="householdLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                            background-color="white"
                            outlined
                          ></v-autocomplete>
                        </div>
                        <div
                          v-if="
                            item.category === 'mens clothing' ||
                              item.category === 'MENS CLOTHING'
                          "
                        >
                          <v-autocomplete
                            :items="clothingLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          v-if="
                            item.category === 'womens clothing' ||
                              item.category === 'WOMENS CLOTHING'
                          "
                        >
                          <v-autocomplete
                            :items="clothingLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                          >
                          </v-autocomplete>
                        </div>

                        <div
                          v-if="
                            item.category === 'living room' ||
                              item.category === 'LIVING ROOM'
                          "
                        >
                          <v-autocomplete
                            :items="householdLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          v-if="
                            item.category === 'bathrooms' ||
                              item.category === 'BATHROOMS'
                          "
                        >
                          <v-autocomplete
                            :items="householdLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                            outlined
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          v-if="
                            item.category === 'jewelry' ||
                              item.category === 'JEWELRY'
                          "
                        >
                          <v-autocomplete
                            :items="jewelryLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                            outlined
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          v-if="
                            item.category === 'linens' ||
                              item.category === 'LINENS'
                          "
                        >
                          <v-autocomplete
                            :items="householdLabels"
                            label="Optional Store Selection"
                            dense
                            v-model="item.userDescription"
                            clearable
                            outlined
                          >
                          </v-autocomplete>
                        </div>
                      </div>
                      <v-expand-transition>
                        <v-card
                          v-if="item.pricing"
                          class="ma-auto pa-0"
                          flat
                          style="background-color: #E3F2FD; border-radius: 26px; border: 1px solid #64B5F6"
                        >
                          <v-card-text>Pricing:</v-card-text>
                          <v-text-field
                            v-model="item.pricing.finalPrice"
                            type="number"
                            prefix="$"
                            label="Current Final Price"
                            outlined
                            rounded
                            dense
                            color="primary"
                            class="ma-3"
                          ></v-text-field>
                          <v-text-field
                            v-model="item.pricing.finalLink"
                            label="LINK"
                            outlined
                            rounded
                            dense
                            color="primary"
                            class="ma-3"
                          ></v-text-field>

                          <a @click="viewItemScreenShot(item)" target="_blank"
                            >SCREENSHOT LINK</a
                          >
                        </v-card>
                      </v-expand-transition>
                    </v-container>
                  </v-card>
                  <!-- </v-card> -->
                  <!-- </v-container> -->
                  <v-card-actions>
                    <v-btn small :disabled="step === 0" text @click="step--">
                      Back
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      color="green"
                      depressed
                      @click="fetchPricing(item)"
                      :disabled="overlay2 || item.quantity === 0"
                      :loading="overlay2"
                      >Auto-Price</v-btn
                    >

                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      color="orange"
                      depressed
                      @click="selfPrice(item)"
                      :disabled="overlay2 || item.quantity === 0"
                      :loading="overlay2"
                      >Self-Price</v-btn
                    >
                    <!-- <v-btn
                      small
                      color="primary"
                      depressed
                      v-if="item.pricing"
                      :disabled="!item.pricing.pdfPath"
                      @click="viewItemScreenShot(item)"
                      :loading="overlay2"
                      >view</v-btn
                    > -->

                    <v-btn
                      small
                      color="primary"
                      depressed
                      v-if="item.pricing"
                      @click="deletePricing(item)"
                      :loading="overlay2"
                      >delete pricing</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      color="primary"
                      depressed
                      @click="nextItem(item)"
                      :disabled="item.quantity > 0 && item.pricing === null"
                      :loading="overlay2"
                    >
                      Next
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-window-item>
              <v-dialog
                v-if="selfPriceDialogData"
                v-model="selfPricingItem"
                max-width="600px"
              >
                <v-card
                  class="mx-auto"
                  max-width="600px"
                  outlined
                  rounded
                  text
                  style="border: 1px #1e88e5 solid"
                >
                  <v-card-text>
                    <v-text-field
                      label="Name of Item"
                      v-model="selfPriceDialogData.title"
                    ></v-text-field>
                    <v-text-field
                      label="Final Price"
                      v-model="tempFinalPrice"
                      type="number"
                      prefix="$"
                      outlined
                      rounded
                      dense
                      color="primary"
                      class="ma-3"
                    ></v-text-field>
                    <v-text-field
                      label="Final Link"
                      v-model="tempFinalLink"
                      outlined
                      rounded
                      dense
                      color="primary"
                      class="ma-3"
                    ></v-text-field>
                    <v-text-field
                      label="Description"
                      v-model="selfPriceDialogData.userDescription"
                      outlined
                      rounded
                      dense
                      color="primary"
                      class="ma-3"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      large
                      rounded
                      @click="selfPriceAndAddItem(selfPriceDialogData)"
                    >
                      ADD
                    </v-btn>
                    <v-btn large rounded @click="cancelSelfPricing()">
                      CANCEL
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-window>
            <v-btn
              small
              color="primary"
              depressed
              @click="report()"
              :disabled="priceOverlay || contentsList.length === 0"
              :loading="priceOverlay"
              >report</v-btn
            >
            <v-btn
              v-if="doc !== null && invoice !== null"
              small
              color="primary"
              depressed
              @click="downloadDocs()"
              :disabled="priceOverlay || contentsList.length === 0"
              :loading="priceOverlay"
              >download</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              v-if="
                matter &&
                  (!matter.contentsListCompleted ||
                    matter.contentsListCompleted === false)
              "
              small
              color="green"
              depressed
              @click="markAsCompleted()"
              >MARK AS COMPLETED</v-btn
            >
            <v-btn
              v-if="
                matter &&
                  (matter.contentsListCompleted &&
                    matter.contentsListCompleted === true)
              "
              small
              color="yellow"
              depressed
              @click="markAsNotCompleted()"
              >MARK AS INCOMPLETE</v-btn
            >
          </v-card>
        </v-expand-transition>
      </v-flex>
      <!-- CONENTS LIST  -->
      <v-flex xs12 sm12 md3 lg3 class="pl-1 pr-1">
        <v-expand-transition>
          <!-- <v-container fluid> -->
          <!-- <v-btn @click="getNextContents">view contents list</v-btn> -->
          <v-navigation-drawer
            permanent
            class="ma-auto mr-4"
            height="70vh"
            width="auto"
            style="border-radius: 26px; border: 1px solid #64B5F6; overflow:auto;"
          >
            <v-btn @click="loadContentsList">LOAD</v-btn>
            <v-btn @click="hideContentsList">HIDE</v-btn>
            <v-autocomplete
              v-if="contentsList"
              :label="`Search Within Contents:`"
              outlined
              rounded
              clearable
              dense
              class="ma-2"
              append-icon="mdi-magnify"
              :items="contentsList"
              item-text="title"
              return-object
              v-model="search2"
            ></v-autocomplete>
            <v-list-item-title class="text-h6">
              CONTENTS LIST
            </v-list-item-title>
            <!-- <v-card-title>CONTENTS LIST</v-card-title> -->
            <v-card-text>
              <ol id="contents-list">
                <li
                  v-for="(thing, j) in contentsList"
                  :key="j"
                  :id="j + 1"
                  style="border-radius: 26px; border: 1px solid #64B5F6;"
                >
                  {{ thing.title }} - {{ thing.category }} | QTY:
                  {{ thing.quantity }} -
                  <div v-if="thing.pricing">
                    ${{ thing.pricing.finalPrice }}
                  </div>
                  <div v-else><v-icon color="red">mdi-alert</v-icon></div>
                  <v-btn small fab @click="deleteContentsListItem(thing)"
                    ><v-icon>mdi-delete</v-icon></v-btn
                  >
                  <v-icon v-if="thing.flag">mdi-flag</v-icon>
                  <v-btn
                    v-if="!thing.flag"
                    small
                    rounded
                    @click="flagItem(thing)"
                    >flag</v-btn
                  >
                  <v-btn
                    v-if="thing.flag"
                    small
                    rounded
                    @click="unFlagItem(thing)"
                    >unflag</v-btn
                  >
                </li>
              </ol>
            </v-card-text>
            <!-- </v-card> -->
          </v-navigation-drawer>
          <!-- </v-container> -->
        </v-expand-transition>
        <v-expand-transition v-if="flags.length > 0">
          <v-flex class="ma-auto pa-0">
            <v-card
              class="ma-2"
              width="auto"
              style="border-radius: 26px; border: 1px solid #64B5F6; overflow:auto;"
            >
              <v-card-title>FLAGGED ITEMS</v-card-title>
              <v-card-text>
                <ul id="contents-list">
                  <li v-for="(flag, n) in flags" :key="n">
                    {{ flag.title }} - {{ flag.category }} | QTY:
                    {{ flag.quantity }} -

                    <!-- <v-btn small fab @click="deleteContentsListItem(thing, j)"
                      ><v-icon>mdi-delete</v-icon></v-btn
                    > -->
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-expand-transition>
      </v-flex>

      <v-expand-transition>
        <v-flex
          xs12
          sm12
          md12
          lg12
          style="
            overflow-x: scroll;
            overflow: auto;
            max-height: 80vh; min-height: 60vh;
          "
          class="ma-auto"
        >
          <v-responsive
            max-height="80vh"
            :aspect-ratio="1.2941 / 1"
            style="
                    overflow-x: scroll;
                    background-color: black;
                    border-radius: 26px;
                  "
            v-if="this.iframeSrc"
          >
            <iframe
              v-if="!overlay"
              style="border: 0"
              :src="iframeSrc"
              width="100%"
              height="100%"
            ></iframe>
          </v-responsive>
        </v-flex>
      </v-expand-transition>
    </v-row>
    <v-dialog v-model="addItemDialog" max-width="600px">
      <v-card
        class="mx-auto"
        max-width="600px"
        outlined
        rounded
        text
        style="border: 1px #1e88e5 solid"
      >
        <v-card-text>
          <v-text-field
            label="Name of Item"
            v-model="newItemName"
          ></v-text-field>
          <v-combobox
            label="Category"
            :items="newItemCategoryList"
            v-model="newItemCategory"
          ></v-combobox>
          <v-text-field
            label="Quantity"
            v-model="newItemQuantity"
            number
            type="number"
          ></v-text-field>
          <v-text-field
            label="Description"
            v-model="newItemDescription"
          ></v-text-field>
          <v-expand-transition>
            <v-text-field
              label="Final Price"
              v-model="tempFinalPrice"
              type="number"
              prefix="$"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
              v-if="selfPricingNewItem"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition>
            <v-text-field
              label="Final Link"
              v-model="tempFinalLink"
              outlined
              rounded
              dense
              color="primary"
              class="ma-3"
              v-if="selfPricingNewItem"
            ></v-text-field>
          </v-expand-transition>
          <v-expand-transition>
            <v-btn
              small
              color="orange"
              depressed
              @click="selfPricingNewItem = true"
              >Self Price This Item</v-btn
            >
          </v-expand-transition>
        </v-card-text>
        <v-card-actions>
          <!-- <v-btn large rounded @click="addNewItem">
            ADD
          </v-btn> -->
          <v-spacer></v-spacer>
          <v-btn
            small
            color="green"
            depressed
            @click="addNewItem"
            :disabled="selfPricingNewItem"
            >Auto-Price</v-btn
          >
          <v-btn
            small
            color="orange"
            depressed
            @click="selfPriceNewItem()"
            v-if="selfPricingNewItem"
            >Self-Price</v-btn
          >
          <v-spacer></v-spacer>

          <v-btn large rounded @click="addItemDialog = false">
            CANCEL
          </v-btn>
        </v-card-actions>

        <!--         -->
      </v-card>
    </v-dialog>
    <!-- </v-container> -->
  </div>
</template>
<script>
import firebase from "firebase";
import slugify from "slugify";
import * as moment from "moment";
// import { PDFDocument, StandardFonts, rgb, PageSizes, drawPage } from "pdf-lib";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  // props: ["matter"],
  data: () => ({
    isMobile: false,
    drawer: true,
    step: 0,
    matter: null,
    selectedMenuItem: 17,
    category: null,
    selectedItem: null,
    tierDialog: false,
    overlay: false,
    overlay2: false,
    oldMatter: null,
    showScreenShot: false,
    showScreenShotSrc: null,
    pricedItemDetails: null,
    menuItems: [],
    items: [],
    doc: null,
    invoice: null,
    iframeSrc: null,
    priceOverlay: false,
    search: null,
    search2: null,
    addItemDialog: false,
    newItemName: null,
    //this should be an array and it should be set the the selected category when the user click "add your own"
    newItemCategory: null,
    newItemQuantity: 0,
    newItemPricing: null,
    newItemDescription: null,
    excludeCategory: false,
    selfPricingItem: false,
    tempFinalPrice: null,
    tempFinalLink: null,
    selfPricingNewItem: false,
    householdLabels: [
      "Williams Sonoma",
      "Restoration Hardware",
      "West Elm",
      "HD Buttercup",
      "Joss and Main",
      "Crate and Barrel",
      "Pottery Barn",
      "Sur La Table",
      "Bed, Bath and Beyond",
      "Costco",
      "Target"
    ],
    clothingLabels: [
      "Nordstrom",
      "Neiman Marcus",
      "Bloomingdales",
      "Macys",
      "Target"
    ],
    jewelryLabels: ["Tiffany", "Ben Bridge", "Bloomingdales", "Zales"],
    selfPriceDialogData: null,
    contentsList: [],
    invoiceNumber: null
  }),
  methods: {
    hideContentsList() {
      this.contentsList = [];
    },
    loadContentsList() {
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .collection("contentsList")
        .onSnapshot(docs => {
          this.contentsList = [];
          docs.forEach(doc => {
            let data = doc.data();
            let id = doc.id;

            if (data.pricing) {
              this.contentsList.push(doc.data());
            } else {
              console.log("missing pricing", id);
              firebase
                .firestore()
                .collection("fireMatters")
                .doc(this.matter.matterID)
                .collection("contentsList")
                .doc(id)
                .delete()
                .then(() => {
                  console.log("deleted", doc.data());
                });
            }
          });
        });
    },
    markAsNotCompleted() {
      this.matter.contentsListCompleted = false;
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .set(this.matter);
    },
    markAsCompleted() {
      this.matter.contentsListCompleted = true;
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .set(this.matter);
    },
    flagItem(thing) {
      // console.log(thing);
      thing.flag = true;
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .collection("contentsList")
        .doc(thing.pricing.searchTerms)
        .set(thing);
    },
    unFlagItem(thing) {
      // console.log(thing);
      thing.flag = false;
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .collection("contentsList")
        .doc(thing.pricing.searchTerms)
        .set(thing);
    },
    selfPrice(item) {
      // console.log("item to be self priced", item);
      this.selfPricingItem = true;
      this.selfPriceDialogData = item;
    },
    cancelSelfPricing() {
      this.tempFinalPrice = null;
      this.tempFinalLink = null;
      this.selfPricingItem = false;
      this.selfPriceDialogData = null;
    },
    selfPriceAndAddItem(item) {
      console.log(item);
      item.pricing = {
        finalPrice: this.tempFinalPrice,
        finalLink: this.tempFinalLink,
        downloadUrl: null
      };
      let terms = item.category + " " + item.title;
      if (item.userDescription !== null && item.userDescription !== undefined) {
        terms = terms + " " + item.userDescription;
      }
      let searchTerms = slugify(terms, {
        replacement: "+",
        remove: /[$*_+~.()'"!\-:@,#]/g,
        lower: true
      });
      item.pricing.searchTerms = searchTerms;
      console.log(item);

      this.saveAndContinue(item);
      firebase
        .firestore()
        .collection("pricedItemList")
        .doc(item.pricing.searchTerms)
        .set(item.pricing);
      this.cancelSelfPricing();
    },
    // handleScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    //   if (scrollTop + clientHeight >= scrollHeight) this.getNextContents();
    // },
    // saveConents() {
    //   this.matter.contentsList.forEach(contentsListItem => {
    //     if (contentsListItem.pricing !== null) {
    //       firebase
    //         .firestore()
    //         .collection("fireMatters")
    //         .doc(this.matter.matterID)
    //         .collection("contentsList")
    //         .doc(contentsListItem.pricing.searchTerms)
    //         .set(contentsListItem);
    //     }
    //   });
    // },
    downloadDocs() {
      if (this.doc !== null && this.invoice !== null) {
        this.doc.download(`PRICING-${this.matter.propertySlug}.pdf`);
        // this.invoice.download(`INVOICE-${this.matter.propertySlug}.pdf`);
      }
    },
    deleteContentsListItem(thing) {
      console.log(thing);
      // this.matter.contentsList.splice(j, 1);
      // firebase
      //   .firestore()
      //   .collection("fireMatters")
      //   .doc(this.matter.matterID)
      //   .set(this.matter);
      let searchTerms = "";
      if (!thing.pricing) {
        let terms = thing.category + " " + thing.title;

        //check if this item has the "searchTerms" property in the toplevel "contentsListItem" after its pricing was deleted.

        if (
          thing.userDescription !== null &&
          thing.userDescription !== undefined
        ) {
          terms = terms + " " + thing.userDescription;
        } else if (thing.searchTerms) {
          terms = thing.searchTerms;
        }
        searchTerms = slugify(terms, {
          replacement: "+",
          remove: /[$*_+~.()'"!\-:@,#]/g,
          lower: true
        });
        console.log("searchTerms", searchTerms);
      } else {
        searchTerms = thing.pricing.searchTerms;
        console.log("has pricing already", searchTerms);
      }
      firebase
        .firestore()
        .collection("fireMatters")
        .doc(this.matter.matterID)
        .collection("contentsList")
        .doc(searchTerms)
        .delete()
        // .then(() => {
        //   this.contentsList.splice(j, 1);
        // })
        .catch(e => {
          console.error(e.message);
        });
    },
    async addNewItem() {
      let ref = Math.floor(Math.random() * 90000) + 10000;

      let cat = await this.newItemCategory
        .replace(/[^\w\s]/gi, "")
        .trim()
        .toUpperCase();

      let newMenuItem = await {
        ref: ref,
        quantity: 0,
        title: this.newItemName,
        comment: null,
        userDescription: null,
        pricing: null,
        category: cat
      };
      //save new menu item to the database
      //save to contents

      await firebase
        .firestore()
        .collection("fireMatters")
        .doc("contents")
        .collection(this.newItemCategory)
        .doc(this.newItemName)
        .set(newMenuItem);
      //add to menuItems list
      //this needs work because it is only pushing it to the menu items not to the category
      // this.menuItems.push(newMenuItem);

      let finalNewItem = await {
        ref: ref,
        quantity: this.newItemQuantity,
        title: this.newItemName,
        comment: null,
        userDescription: this.newItemDescription,
        pricing: null,
        category: this.newItemCategory
      };
      //price the item --EXPERIMENT
      await this.fetchPricing(finalNewItem).then(() => {
        this.newItemName = null;
        this.newItemCategory = "";
        this.newItemQuantity = 0;
        this.newItemPricing = null;
        this.newItemDescription = null;
        this.addItemDialog = false;
      });
    },
    async selfPriceNewItem() {
      //create a ref number
      let ref = Math.floor(Math.random() * 90000) + 10000;
      //make sure category is formatted correctly
      let cat = await this.newItemCategory
        .replace(/[^\w\s]/gi, "")
        .trim()
        .toUpperCase();
      //create a new menuItem to be added to the menueItems in database
      let newMenuItem = await {
        ref: ref,
        quantity: 0,
        title: this.newItemName,
        comment: null,
        userDescription: null,
        pricing: null,
        category: cat
      };
      //save new menu item to the database
      //save to contents

      await firebase
        .firestore()
        .collection("fireMatters")
        .doc("contents")
        .collection(this.newItemCategory)
        .doc(this.newItemName)
        .set(newMenuItem);

      //create the new Item with pricing
      let finalNewItem = await {
        ref: ref,
        quantity: this.newItemQuantity,
        title: this.newItemName,
        comment: null,
        userDescription: this.newItemDescription,
        pricing: {
          finalPrice: this.tempFinalPrice,
          finalLink: this.tempFinalLink,
          downloadUrl: null,
          searchTerms: null
        },
        category: this.newItemCategory
      };

      let terms = finalNewItem.category + " " + finalNewItem.title;
      let searchTerms = await slugify(terms, {
        replacement: "+",
        remove: /[$*_+~.()'"!\-:@,#]/g,
        lower: true
      });
      finalNewItem.pricing.searchTerms = await searchTerms;
      //save the nerw self priced item to the user's contentsList
      this.saveAndContinue(finalNewItem);
      let newPricedItemListItem = await {
        finalPrice: this.tempFinalPrice,
        finalLink: this.tempFinalLink,
        downloadUrl: null,
        searchTerms: searchTerms,
        titleSlug: searchTerms,
        pdfPath: null
      };
      //add the new self priced item to the pricedItemList so that the next time it needs a price it can have it ready

      await firebase
        .firestore()
        .collection("pricedItemList")
        .doc(searchTerms)
        .set(newPricedItemListItem)
        .then(() => {
          this.newItemName = null;
          this.newItemCategory = "";
          this.newItemQuantity = 0;
          this.newItemPricing = null;
          this.newItemDescription = null;
          this.selfPricingNewItem = false;
          this.tempFinalPrice = null;
          this.tempFinalLink = null;
        });
    },
    viewItemScreenShot(item) {
      this.overlay = true;
      if (item.pricing.pdfPath !== null && item.pricing.pdfPath !== undefined) {
        //if ther is a pdfPath property (this is actually a .png)
        //get the download url for the new pricing screenshot
        let screenShotRef = firebase
          .storage()
          .refFromURL(`gs://taplaw.appspot.com/${item.pricing.pdfPath}`);
        screenShotRef
          .getDownloadURL()
          .then(url => {
            window.open(url, item.title);
            item.pricing.downloadUrl = url;
            this.showScreenShotSrc = url;
            item.pricing.pricingError = null;

            firebase
              .firestore()
              .collection("pricedItemList")
              .doc(item.pricing.searchTerms)
              .set(item.pricing);
            this.saveAndContinue(item);
            this.overlay = false;
          })
          .catch(e => console.error(e.message));
      } else {
        this.overlay = false;
        alert("there is no screenshot for this item", item);
      }
    },
    nextItem(item) {
      //if item has a quantity > 0 and the item has a price
      if (item.quantity > 0 && item.pricing !== null) {
        // if quantity > 0 and item has pricing
        //save the item to the contentsList
        // console.log(item);

        firebase
          .firestore()
          .collection("fireMatters")
          .doc(this.matter.matterID)
          .collection("contentsList")
          .doc(item.pricing.searchTerms)
          .set(item);
        //go to next step
        this.step++;
      } else if (item.quantity > 0 && !item.pricing) {
        //if the item quantity is > 0 and there is no pricing for the item
        this.fetchPricing(item);
        this.step++;
      } else if (item.quantity < 1) {
        this.step++;
      }
    },
    async saveAndContinue(item) {
      console.log("saving item", item);
      //if the quantity is > 0
      if (item.quantity > 0) {
        // console.log("saving item");
        let searchTerms = "";
        if (!item.pricing) {
          let terms = item.category + " " + item.title;
          searchTerms = slugify(terms, {
            replacement: "+",
            remove: /[$*_+~.()'"!\-:@,#]/g,
            lower: true
          });
        } else {
          searchTerms = item.pricing.searchTerms;
        }
        // console.log(searchTerms);
        await firebase
          .firestore()
          .collection("fireMatters")
          .doc(this.matter.matterID)
          .collection("contentsList")
          .doc(searchTerms)
          .set(item)
          .then(() => {
            console.log("item saved to user's contents list");
          })
          .catch(e => console.error(e.message));

        //go to next step (item)
        // this.step++;
      } else {
        // console.log("deleting item with 0 quantity");
        let searchTerms = "";
        if (item.pricing.searchTerms) {
          searchTerms = item.pricing.searchTerms;
        } else {
          let terms = item.category + " " + item.title;
          searchTerms = slugify(terms, {
            replacement: "+",
            remove: /[$*_+~.()'"!\-:@,#]/g,
            lower: true
          });
        }
        await firebase
          .firestore()
          .collection("fireMatters")
          .doc(this.matter.matterID)
          .collection("contentsList")
          .doc(searchTerms)
          .get()
          .then(doc => {
            if (doc.exists) {
              firebase
                .firestore()
                .collection("fireMatters")
                .doc(this.matter.matterID)
                .collection("contentsList")
                .doc(searchTerms)
                .delete(item);
            } else {
              // console.log("this item does not exist");
            }
          });
      }
      //if quantity =0
      //go to next step (item)

      // this.step++;
      // }
      this.excludeCategory = false;
      // this.step++;
    },
    // logStep() {
    // console.log("this.step", this.step);
    // },
    // logChange(step) {
    //   step = 0;
    //   console.log("window has changed, step =", step);
    //   console.log("window @change this is $data = ", this.$data);
    // },
    async fetchPricing(item) {
      // RUN FUNCTION IN EMULATOR
      // firebase
      //   .app()
      //   .functions("us-west2")
      //   .useFunctionsEmulator("http://localhost:5001");

      // const getPricing = firebase
      //   .app()
      //   .functions("us-west2")
      //   .httpsCallable("getPricing", { timeout: 0 });

      const getPricing2 = firebase
        .app()
        .functions("us-west2")
        .httpsCallable("getPricing2", { timeout: 0 });

      //if the quantity of this item is >0 && there is no pricing for the item
      // console.log("item", item);
      this.overlay = true;
      if (item.quantity > 0 && !item.pricing) {
        //SANITIZE THE TITLE OF THE OBJECT
        let title = item.title.replace(/ *\([^)]*\) */g, "");
        //IF THERE IS A USER DESCRIPTION ON THE OBJECT
        if (item.userDescription !== null && this.excludeCategory === false) {
          //MAKE THE TITLE INCLUDE THE USER DESCRIPTION
          title = item.category + " " + title + " " + item.userDescription;
        } else if (
          this.excludeCategory === true &&
          item.userDescription !== null
        ) {
          title = title + ` ${item.userDescription || " "}`;
        } else {
          title = item.category + " " + title;
        }
        //THIS IS WHAT WILL BE SEARCHED BY THE HEADLESS BROWSER
        let searchTerms = slugify(title, {
          replacement: "+",
          remove: /[$*_+~.()'"!\-:@,#]/g,
          lower: true
        });
        let itemSlug = searchTerms;

        let titleSlug = slugify(item.title, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@,#]/g,
          lower: true
        });

        // console.log("titleSlug", titleSlug);
        // console.log("itemSlug", itemSlug);

        //DATA THAT IS FED TO THE GETPRICING FUNCTION
        let functionData = {
          itemSlug: itemSlug,
          desc: item.title,
          titleSlug
        };
        console.log("item being priced", item);
        console.log("functionData for getPricing", functionData);
        console.log("searchTerms", searchTerms);

        // console.log("functionData: ", functionData);
        // CHECK IF THE ITEM IS PRICED ALREADY
        firebase
          .firestore()
          .collection("pricedItemList")
          .doc(searchTerms)
          .get()
          .then(resp => {
            // console.log("resp from checking if price exists", resp);
            //IF THERE IS A PRICING OBJECT IN THE DATABASE
            if (resp.exists == true) {
              // console.log("hell ya it exists!");
              //set the pricing to the response from get(existingPricing data)
              item.pricing = resp.data();
              //go to next step

              this.saveAndContinue(item);
              this.overlay = false;
            } else {
              //IF THER IS NO PRICING OBJECT IN DATABASE
              //GET PRICING

              // getPricing(functionData)
              getPricing2(functionData)
                .then(async resp => {
                  // console.log("resp.data = ", resp.data);
                  let pricing = await resp.data;
                  pricing.titleSlug = titleSlug;
                  pricing.searchTerms = searchTerms;
                  if (
                    pricing.pdfPath !== null &&
                    pricing.pdfPath !== undefined
                  ) {
                    //if ther is a pdfPath property (this is actually a .png)
                    //get the download url for the new pricing screenshot
                    let screenShotRef = firebase
                      .storage()
                      .refFromURL(`gs://taplaw.appspot.com/${pricing.pdfPath}`);
                    console.log("pricing.pdfPath", pricing.pdfPath);

                    await screenShotRef
                      .getDownloadURL()
                      .then(url => {
                        window.open(url, "_blank");
                        pricing.downloadUrl = url;
                        this.showScreenShotSrc = url;
                        pricing.pricingError = null;

                        firebase
                          .firestore()
                          .collection("pricedItemList")
                          .doc(searchTerms)
                          .set(pricing);
                        //   item.pricing = pricing
                        // this.saveAndContinue(item);
                        this.overlay = false;
                      })
                      .catch(e => console.error(e.message));
                  } else {
                    //if there is no pdfPath (this is actually a .png)
                    pricing.downloadUrl = null;
                  }
                  //set the item's pricing
                  item.pricing = await pricing;
                  //save and continue
                  await this.saveAndContinue(item);
                  this.overlay = false;
                })
                .catch(e => {
                  console.error(e.message);
                  // console.log("trying this item again");
                  functionData = {
                    itemSlug: searchTerms,
                    desc: item.title,
                    titleSlug
                  };

                  console.log("item being priced again", item);
                  console.log(
                    "functionData for getPricing again",
                    functionData
                  );
                  console.log("searchTerms again", searchTerms);

                  // getPricing(functionData)
                  getPricing2(functionData)
                    .then(async resp => {
                      let pricing = resp.data;
                      pricing.titleSlug = titleSlug;
                      pricing.searchTerms = searchTerms;
                      if (
                        pricing.pdfPath !== null &&
                        pricing.pdfPath !== undefined
                      ) {
                        //if ther is a pdfPath property (this is actually a .png)
                        //get the download url for the new pricing screenshot
                        let screenShotRef = firebase
                          .storage()
                          .refFromURL(
                            `gs://taplaw.appspot.com/${pricing.pdfPath}`
                          );
                        console.log("pricing.pdfPath", pricing.pdfPath);
                        await screenShotRef
                          .getDownloadURL()
                          .then(url => {
                            window.open(url, "_blank");
                            pricing.downloadUrl = url;
                            this.showScreenShotSrc = url;
                            pricing.pricingError = null;

                            firebase
                              .firestore()
                              .collection("pricedItemList")
                              .doc(searchTerms)
                              .set(pricing);
                            this.saveAndContinue(item);
                            this.overlay = false;
                          })
                          .catch(e => console.error(e.message));
                      } else {
                        //if there is no pdfPath (this is actually a .png)
                        pricing.downloadUrl = null;
                      }
                      //set the item's pricing
                      item.pricing = await pricing;
                      //save and continue
                      await this.saveAndContinue(item);
                      this.overlay = false;
                    })
                    .catch(e => {
                      console.error(e.message);
                      this.overlay = false;
                    });
                });
            }
          })
          .catch(e => console.error(e.message));
        //if yes
        //add the pricing to this item.pricing
        //if no
        //get the pricing (getPricing() cloud funtion)
        //add the response to the item.pricing
      } else {
        //if quantity = 0 or item is already priced

        this.overlay = false;
        // this.step++;
      }
    },
    deletePricing(item) {
      console.log(item);
      const searchTerms = item.pricing.searchTerms;
      firebase
        .firestore()
        .collection("pricedItemList")
        .doc(item.pricing.searchTerms)
        .get()
        .then(resp => {
          if (resp.exists == true) {
            firebase
              .firestore()
              .collection("pricedItemList")
              .doc(item.pricing.searchTerms)
              .delete()
              .then(() => {
                item.searchTerms = item.pricing.searchTerms;
                item.pricing = null;

                firebase
                  .firestore()
                  .collection("fireMatters")
                  .doc(this.matter.matterID)
                  .collection("contentsList")
                  .doc(searchTerms)
                  .set(item)
                  // .then(() => {
                  //   console.log("removed pricing");
                  // })
                  .catch(e => console.error(e.message));
              })
              .catch(e => console.error(e.message));
          } else {
            item.searchTerms = item.pricing.searchTerms;
            item.pricing = null;

            firebase
              .firestore()
              .collection("fireMatters")
              .doc(this.matter.matterID)
              .collection("contentsList")
              .doc(searchTerms)
              .delete()
              // .then(() => {
              //   console.log("removed pricing");
              // })
              .catch(e => console.error(e.message));
          }
        })

        //           // let index = this.matter.contentsList.findIndex(
        //           let index = this.contentsList.findIndex(
        //             contentsListItem => contentsListItem.ref === item.ref
        //           );
        //           // this.matter.contentsList[index].pricing = null;
        //           this.contentsList[index].pricing = null;
        //           console.log("item Deleted from pricedItemList");
        //           this.saveAndContinue(item);
        //         })
        //         .catch(e => console.error(e.message));
        //     } else {
        //       item.pricing = null;
        //       // let index = this.matter.contentsList.findIndex(
        //       let index = this.contentsList.findIndex(
        //         contentsListItem => contentsListItem.ref === item.ref
        //       );
        //       // this.matter.contentsList[index].pricing = null;
        //       this.contentsList[index].pricing = null;
        //       console.log("item Deleted from pricedItemList");
        //       this.saveAndContinue(item);
        //     }
        // })

        .catch(e => console.error(e.message));
    },
    report() {
      // console.log("contentsList", this.matter.contentsList);
      // const list = this.matter.contentsList;
      let list = [];
      // this.matter.contentsList.forEach(contentsListItem => {
      this.contentsList.forEach(contentsListItem => {
        // if (contentsListItem.pricing === null) {
        //   console.log("undefined pricing", contentsListItem);
        // }
        contentsListItem.category.toUpperCase();
        // if (contentsListItem.category === "MISCELLANEUOS") {
        //   contentsListItem.category == "MISCELLANEOUS";
        // }
        list.push(contentsListItem);
        // this.matter.contentsList = list;
        // firebase
        //   .firestore()
        //   .collection("fireMatters")
        //   .doc(this.matter.propertySlug)
        //   .set(this.matter);
      });
      pdfMake.fonts = {
        TimesRoman: {
          normal: "Times New Roman.ttf",
          bold: "Times New Roman Bold.ttf",
          italics: "Times New Roman Italic.ttf",
          bolditalics: "Times New Roman Bold Italic.ttf"
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf"
        },
        Zapfino: {
          normal: "Zapfino.ttf"
        }
      };

      // let filteredContentsList = [];
      this.priceOverlay = true;
      let tableBody = [
        [
          { text: "REF", alignment: "center" },
          { text: "CATEGORY", alignment: "center" },
          { text: "QTY", alignment: "center" },
          { text: "DESCRIPTION", alignment: "center" },
          { text: "PRICE", alignment: "center" },
          { text: "ITEM TOTAL", alignment: "center" },
          { text: "SOURCE", alignment: "center" },
          { text: "SCREENSHOT", alignment: "center" },
          { text: "NOTES", alignment: "center" },
          { text: "COMMENTS", alignment: "center" }
        ]
      ];
      // let itemList = [];
      /////test below

      let group = list.reduce((r, a) => {
        r[a.category.toUpperCase()] = [
          ...(r[a.category.toUpperCase()] || []),
          a
        ];
        return r;
      }, {});
      // console.log("group", group);
      // for (const [key, value] of Object.entries(group)) {
      //   console.log("key", key);
      //   console.log("value", value);
      // }

      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(group)) {
        // console.log(key);

        value.forEach(item => {
          if (item.quantity > 0) {
            if (item.pricing !== null && item.pricing !== undefined) {
              let qty = Number.parseInt(item.quantity);
              let finPrice = Number.parseFloat(item.pricing.finalPrice).toFixed(
                2
              );
              let itemTot = qty * finPrice;
              let totDolar = Number.parseFloat(itemTot).toFixed(2);
              tableBody.push([
                item.ref,
                item.category.toUpperCase(),

                qty,

                item.title,

                `$${finPrice}`,
                `$${totDolar}`,

                {
                  text: `view`,
                  link: item.pricing.finalLink
                },
                { text: `view`, link: item.pricing.downloadUrl },

                item.userDescription,
                item.comment
              ]);
            }
          }
        });
      }

      let summaryBody = [
        [
          { text: "CATEGORY", alignment: "center" },
          { text: "TOTAL FOR CATEGORY", alignment: "center" }
        ]
      ];

      let grandTotal = 0;

      for (const [key, value] of Object.entries(group)) {
        let total = 0;

        value.forEach(item => {
          let quantity = Number.parseInt(item.quantity);
          let finalPrice = Number.parseFloat(item.pricing.finalPrice).toFixed(
            2
          );
          let itemPrice = finalPrice * quantity;
          total = total + itemPrice;
        });
        let categoryTotal = Number.parseFloat(total).toFixed(2);
        grandTotal += total;
        summaryBody.push([
          { text: `${key.toUpperCase()}`, alignment: "center" },
          {
            text: `$${categoryTotal
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`,
            alignment: "center"
          }
        ]);
      }
      let almostFinalGrandTotal = Number.parseFloat(grandTotal).toFixed(2);
      let finalGrandTotal = new Intl.NumberFormat().format(
        almostFinalGrandTotal
      );
      let itemCount = 0;
      // this.matter.contentsList.forEach(listItem => {
      this.contentsList.forEach(listItem => {
        let quantity = Number.parseInt(listItem.quantity);
        itemCount = itemCount + quantity;
      });
      // console.log("itemCount", itemCount);

      // let invoiceTotal = itemCount * 0.75;
      // let invoiceTotal = this.matter.contentsList.length * 0.75;
      let invoiceTotal = this.contentsList.length * 0.75;

      let totalDue = Number.parseFloat(invoiceTotal).toFixed(2);
      summaryBody.push([
        { text: `GRAND TOTAL`, alignment: "center", bold: true },
        { text: `$${finalGrandTotal}`, alignment: "center", bold: true }
      ]);
      // console.log(summaryBody);
      let docDefinition = {
        // a string or { width: number, height: number }
        // images,
        defaultStyle: {
          // alignment: 'justify',
          font: "TimesRoman",
          fontSize: 12
        },
        pageSize: "LETTER",
        // by default we use portrait, you can change it to landscape if you wish
        pageOrientation: "landscape",
        // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
        pageMargins: [30, 30, 30, 30],
        // pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        //   return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
        // },
        content: [
          {
            table: {
              // headerRows: 1,
              widths: ["*"],
              dontBreakRows: true,
              // keepWithHeaderRows: 1,
              body: [
                [
                  {
                    text: `${this.matter.lastName}, ${this.matter.firstName} - ${this.matter.caseName}`,
                    alignment: "center",
                    bold: true
                  }
                ],
                [
                  {
                    text: ` `
                  }
                ],
                [
                  {
                    text: `SUMMARY`,
                    alignment: "center",
                    bold: true
                  }
                ],
                [
                  {
                    text: ` `
                  }
                ]
              ]
            }
          },
          {
            table: {
              headerRows: 1,
              widths: ["*", "*"],
              body: summaryBody
            },
            pageBreak: "after"
          },

          {
            table: {
              headerRows: 1,
              widths: [30, 100, 25, 100, 50, 50, 50, "*", "*", "*"],
              dontBreakRows: true,
              // keepWithHeaderRows: 1,
              body: tableBody
              // body: finalTableBody
            }
          }
        ],
        footer: currentPage => {
          return [
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      stack: [
                        {
                          text: `${currentPage.toString()}`,
                          alignment: "center",
                          fontSize: 9
                        },
                        {
                          text: `${this.matter.firmName} - ${this.matter.caseID}`,
                          alignment: "right",
                          fontSize: 8
                        }
                      ],
                      layout: { defaultBorder: false },
                      border: [false, false, false, false]
                    }
                  ]
                ]
              }
            }
          ];
        }
      };
      this.doc = pdfMake.createPdf(docDefinition);

      // this.doc.download(`PRICING-${this.matter.propertySlug}.pdf`);
      this.doc.getDataUrl(url => {
        this.iframeSrc = url;
      });

      this.priceOverlay = false;
      let invoiceNumber = Math.floor(Math.random() * 90000) + 10000;
      this.invoiceNumber = invoiceNumber;

      let docDefinitionInvoice = {
        defaultStyle: {
          // alignment: 'justify',
          font: "TimesRoman",
          fontSize: 12
        },
        pageSize: "LETTER",

        pageMargins: [30, 30, 30, 30],
        // pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        //   return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0;
        // },
        content: [
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 595 - 2 * 40,
                y2: 5,
                lineWidth: 3
              }
            ]
          },

          { text: `TAPLAW INVOICE`, fontSize: 20 },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: "TAPLAW INC.", fontSize: 12 },
          { text: "352 S Cloverdale Ave.", fontSize: 12 },
          { text: "Los Angeles, CA 90036", fontSize: 12 },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: `TO: ` },
          { text: `${this.matter.firmName}` },
          { text: `${this.matter.firmAddressLine}` },
          { text: `${this.matter.firmCityStateZip}` },
          { text: `${this.matter.firmPhone}` },

          { text: " " },
          { text: " " },
          { text: " " },
          { text: "Please make checks payable to Taplaw Inc.", fontSize: 12 },
          { text: "Tax ID #: 87-4047075", fontSize: 12 },
          { text: " " },
          { text: " " },
          { text: " " },
          {
            text: `RE: ${this.matter.caseID} - ${this.matter.caseName} - ${this.matter.firstName} ${this.matter.lastName}`
          },
          {
            text: `Invoice No: ${invoiceNumber}`,
            fontSize: 20
          },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: `DATE:  ${moment().format("LL")}` },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          { text: " " },
          {
            table: {
              headerRows: 1,
              dontBreakRows: true,
              widths: ["*", "*"],
              body: [
                [
                  { text: `ITEM`, alignment: "center" },
                  { text: `AMOUNT DUE`, alignment: "center" }
                ],
                [
                  {
                    // text: `Contents List Pricing - \n ${itemCount} Items Priced ($0.75  per item)`,
                    text: `Contents List Pricing - \n ${this.contentsList.length} Items Priced ($0.75  per item)`,
                    alignment: "center"
                  },
                  { text: `$${totalDue}`, alignment: "center" }
                ]
              ]
            }
          }
        ]
      };

      this.invoice = pdfMake.createPdf(docDefinitionInvoice);
    },
    async searchItem(item) {
      //find the category index
      let index = this.menuItems.findIndex(
        menuItem => menuItem.toUpperCase() === item.category.toUpperCase()
      );
      //set the selectedMenuItem
      this.selectedMenuItem = index;
      //go to the
      // console.log(item);
      this.step = item.step;
    },
    onResize() {
      this.isMobile = window.innerWidth < 800;
    },
    // async getNextContents() {
    //   console.log("getting contents ");
    //   const ref = firebase
    //     .firestore()
    //     .collection("fireMatters")
    //     .doc(this.matter.matterID)
    //     .collection("contentsList")
    //     .orderBy("category")
    //     .startAfter(this.latestDoc || 0)
    //     .limit(20);

    //   let list = await ref.get();
    //   if (!list.empty) {
    //     list.docs.forEach(item => {
    //       this.contentsList.push(item.data());
    //     });

    //     this.latestDoc = list.docs[list.docs.length - 1];
    //   }
    // },
    /////////////////////////////////////////////////////////
    //GET THE MENU

    //CREATE A DOCUMENT CALLED CONTENTS (LIMIT ACCESS TO ONLY CLIENT USERS)

    //FOR EACH CATEGORY IN MENU

    //CREATE A COLLECTION (HOW TO NAME?? -- TITLE)

    //FOR EACH SUBITEM

    //SAVE TO A DOCUMENT UNDER CATEGORY COLLECTION (NAME??)

    //IF THE USER ADDS IT TO THEIR CONTENTS LIST, PRICE THE ITEM

    /////////////////////////////////////////////////////////
    async createMenuItems() {
      // GET THE MENU
      // USE EMULATOR
      // console.log("working...");
      let menu = [];
      // firebase
      //   .app()
      //   .functions()
      //   .useFunctionsEmulator("http://localhost:5001");

      const getMenu = firebase
        .functions()
        .httpsCallable("getMenu", { timeout: 0 });
      getMenu()
        .then(async resp => {
          menu = resp.data;
          //FOR EACH CATEGORY IN MENU
          //CREATE A COLLECTION (HOW TO NAME?? -- TITLE)
          await menu.forEach(async category => {
            await category.subItems.forEach(async item => {
              await item.title.replace(/\//g, " ");
              // console.log(item.title);
              await firebase
                .firestore()
                .collection("fireMatters")
                .doc("contents")
                .collection(category.title)
                .doc(item.title)
                .set(item);
            });
          });
        })
        .catch(e => console.error(e.message));
      // console.log("done!");
      //FOR EACH ITEM RETURNED FROM CONTENTS

      //ADD TO MENU (WITH AN ACTIVE CLASS) AND SEARCH BAR
      this.menuItems = menu;
      // })
    }
  },
  computed: {
    // step() {
    //   return;
    // }
    newItemCategoryList() {
      return this.menuItems;
    },
    flags() {
      let array = [];
      this.contentsList.forEach(item => {
        if (!item.pricing || !item.pricing.finalPrice) {
          array.push(item);
        }
      });
      return array;
    }
  },
  watch: {
    search(val) {
      // console.log(val);
      this.step = val.step;
    },
    // step(val) {
    //   console.log("step from data", val);
    // },
    async selectedMenuItem(val) {
      this.items = [];
      // this.step = 0;
      // console.log("selectedMenuItem:", val);
      // console.log("selectedMenuItem:", this.menuItems[val]);
      // this.step = 0;
      //GET ITEMS FOR THIS CATEGORY
      if (val !== undefined && val !== null) {
        // this.step = 0;
        let category = this.menuItems[val];
        this.category = this.menuItems[val];
        this.items = [];
        // console.log("items from data - should be empty", this.items);
        const itemRef = firebase
          .firestore()
          .collection("fireMatters")
          .doc("contents")
          .collection(category);
        this.overlay = true;
        let snapShot = await itemRef.get();
        let count = 0;
        snapShot.forEach(item => {
          //find the item in the user's contents list
          let itemData = item.data();
          // let foundContentsListItem = this.matter.contentsList.find(
          let foundContentsListItem = this.contentsList.find(
            contentsListItem => contentsListItem.ref === itemData.ref
          );
          if (
            foundContentsListItem !== undefined &&
            foundContentsListItem !== null
          ) {
            this.items.push({ ...foundContentsListItem, step: count });
          } else {
            this.items.push({ ...itemData, step: count });
          }
          count++;
        });
        // console.log("items from data - should not be null", this.items);
        this.step = 0;

        this.overlay = false;
      }
    }
    // contentsList(val) {
    //   val.forEach(item => {
    //     if (!item.pricing || !item.pricing.finalPrice) {
    //       let id = "";
    //       if (item.searchTerms) {
    //         id = item.searchTerms;
    //       } else if (item.userDescription) {
    //         id = item.category + " " + item.title + " " + item.userDescription;
    //       } else if (!item.searchTerms && !item.userDescription) {
    //         id = item.category + " " + item.title;
    //       }
    //       firebase
    //         .firestore()
    //         .collection("fireMatters")
    //         .doc(this.matter.matterID)
    //         .collection("contentsList")
    //         .doc(id)
    //         .get()
    //         .then(doc => {
    //           if (doc.exists) {
    //             firebase
    //               .firestore()
    //               .collection("fireMatters")
    //               .doc(this.matter.matterID)
    //               .collection("contentsList")
    //               .doc(id)
    //               .delete();
    //           } else {
    //             console.log("no such item");
    //           }
    //         });
    //     }
    //   });
    // }

    // user(val) {
    //   console.log("user from watch", val);
    // },
    // matter(val) {
    // },
    // isMobile(val) {
    //   if (val === true) {
    //     this.drawer = !this.drawer;
    //   } else {
    //     this.drawer = true;
    //   }
    // },
  },
  created() {
    console.log("hello from contents stepper 2");
    firebase
      .firestore()
      .collection("fireMatters")
      .doc(this.$route.params.location)
      .get()
      .then(res => {
        // console.log("res.data()", res.data());
        this.matter = res.data();
        this.oldMatter = res.data();
      })
      .then(() => {
        //USER SIGNS IN
        //USER APP REQUESTS EACH COLLECTION IN 'CONTENTS' DOCUMENT
        // firebase
        //   .app()
        //   .functions()
        //   .useFunctionsEmulator("http://localhost:5001");

        const getCategories = firebase
          .functions()
          .httpsCallable("getCategories", { timeout: 0 });

        getCategories()
          .then(resp => {
            // console.log(resp.data);
            //FOR EACH ITEM RETURNED FROM CONTENTS
            //ADD TO MENU (WITH AN ACTIVE CLASS) AND SEARCH BAR
            resp.data.forEach(menuItem => {
              this.menuItems.push(menuItem.toUpperCase());
            });
            // this.menuItems = resp.data;
            // console.log("selectedMenuItem: ", this.selectedMenuItem);
            let category = this.menuItems[this.selectedMenuItem];
            this.items = [];
            // console.log("items from data - should be empty", this.items);
            this.overlay = true;
            firebase
              .firestore()
              .collection("fireMatters")
              .doc("contents")
              .collection(category)
              .get()
              .then(resp => {
                let count = 0;
                resp.forEach(item => {
                  let itemData = item.data();
                  // let foundContentsListItem = this.matter.contentsList.find(
                  let foundContentsListItem = this.contentsList.find(
                    contentsListItem => contentsListItem.ref === itemData.ref
                  );
                  if (
                    foundContentsListItem !== undefined &&
                    foundContentsListItem !== null
                  ) {
                    this.items.push({ ...foundContentsListItem, step: count });
                  } else {
                    this.items.push({ ...itemData, step: count });
                  }
                  count++;

                  // this.items.push({ ...item.data(), step: count });
                  // count++;
                });
                // console.log("items from data - should not be null", this.items);

                this.overlay = false;
              });
            // .then(() => {
            //   firebase
            //     .firestore()
            //     .collection("fireMatters")
            //     .doc(this.matter.matterID)
            //     .collection("contentsList")
            //     .onSnapshot(docs => {
            //       this.contentsList = [];
            //       docs.forEach(doc => {
            //         let data = doc.data();
            //         let id = doc.id;

            //         if (data.pricing) {
            //           this.contentsList.push(doc.data());
            //         } else {
            //           console.log("missing pricing", id);
            //           firebase
            //             .firestore()
            //             .collection("fireMatters")
            //             .doc(this.matter.matterID)
            //             .collection("contentsList")
            //             .doc(id)
            //             .delete()
            //             .then(() => {
            //               console.log("deleted", doc.data());
            //             });
            //         }
            //       });
            //     });
            //   // this.getNextContents()
            //   //   .then(() => {
            //   //     console.log("done getting contents list");
            //   //   })
            //   //   .catch(e => console.error(e.message));
            // })
            // .catch(e => console.error(e));

            // let itemList = [];
          })
          .catch(e => console.error(e));

        //ON CLICK MENU ITEM
        // SET TO 'SELECTED MENU ITEM'
        //REQUEST ALL SUBITEMS FOR SELECTED MENU ITEM
        //CREATE A SEARCH BAR FOR THE SUBITEMS (GO TO STEP ETC..)
        //CREATE NEW WINDOW ITEMS FOR EACH ITEM
        //INCLUDE NEXT BUTTON AND QUANTITY BUTTONS
      })
      .catch(e => console.error(e));

    firebase
      .firestore()
      .collection("fireMatters")
      .doc(this.$route.params.location)
      .onSnapshot(res => {
        this.matter = res.data();
        this.oldMatter = res.data();
      });

    // Initially load some items.
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    // Detect when scrolled to bottom.
    // const listElm = document.querySelector("#contents-list");
    // listElm.addEventListener("scroll", () => {
    //   if (listElm.scrollTop === listElm.scrollHeight - listElm.offsetHeight) {
    //     this.getNextContents();
    //   }
    // });
  }
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.sub-item-active {
  background-color: black;
  color: white !important;
}
</style>
